import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, DialogActions, DialogContent, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import AuthUserContainer from '../../../../containers/AuthUser';
import Transition from '../../../../components/dialogs/Transition';
import FormCheckbox from '../../../../components/form/FormCheckbox';
import FormTextArea from '../../../../components/form/FormTextArea';
import FormComponent from '../../../../components/FormComponent';
import { post } from '../../../../modules/utility';
import { unloadingDelayReason } from '../delayReasons';
import { dialogStyles } from './dialogStyles';
import MobileDeliveryDialogSavePopup from './MobileDeliveryDialogSavePopup';
import MobileScannerDialog from './mobileScannerDialog/MobileScannerDialog';
import MobileImageZoomDialog from './MobileImageZoomDialog';

const styles = () => {
	return {
		...dialogStyles,
		scanDocumentButton: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			//color: 'white',
			padding: `3.33vw 5.8vw`,
			lineHeight: 1,
			borderRadius: '1vw',
			marginTop: '1.4vw',
			//minWidth: '30vw',
		},
	};
};

class MobileDeliveryConsigneeDelayDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isScannerOpen: false,
			isZoomOpen: false,
			hasNewScanAndHasNotSave: false,
			photoResources: [],
		};
	}

	componentDidMount() {
		const { delays } = this.props;
		if (!delays) {
			return;
		}
		this.fillForm({ delays });
	}

	fillForm = ({ delays }) => {
		if (_.isEmpty(delays)) {
			return;
		}

		const newState = {};
		delays.forEach(({ delayReason, delayNotes, photoResources }) => {
			newState.delayNotes = delayNotes;
			if (delayReason) {
				newState[delayReason] = true;
			}
			if (!_.isEmpty(photoResources)) {
				newState.photoResources = photoResources;
			}
		});
		return this.setState(newState);
	};

	handleSaveConsigneeDelay = () => {
		const { stopNumber, tmwOrderId } = this.props;
		const { delayNotes, photoResources } = this.state;
		const formFieldError = {};

		let delayReasons = [];
		unloadingDelayReason.forEach((unloadingDelayReason) => {
			if (this.state[unloadingDelayReason.value]) {
				delayReasons.push(unloadingDelayReason.value);
			}
		});

		if (_.isEmpty(delayReasons)) {
			formFieldError.superDuper = 'Must select a delay reason';
		} else {
			if (_.find(delayReasons, 'other') && !delayNotes) {
				formFieldError.delayNotes = 'Other requires some additional notes';
			}
		}

		if (_.keys(formFieldError).length) {
			this.setState({
				formFieldError,
				isSaving: false,
				hasSavingSuccess: false,
				hasSavingError: true,
				savingError: _.values(formFieldError).join('.'),
			});
			return;
		}

		let photoResourceIds = [];
		if (!_.isEmpty(photoResources)) {
			photoResourceIds = _.map(photoResources, 'resourceId');
		}

		this.setState({ isSaving: true });
		post({
			method: 'tmw.deliveryTicket.updateDelay',
			params: {
				tmwOrderId,
				stopNumber,
				delayType: 'consignee',
				delayReasons,
				delayNotes,
				photoResourceIds,
			},
			callback: (err, _r) => {
				if (err) {
					return this.setState({
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}

				this.setState({
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
				});

				setTimeout(() => {
					this.setState({
						hasSavingSuccess: false,
					});
				}, 3000);
			},
		});
	};

	handleClose = () => {
		this.setState({
			isSaving: false,
			hasSavingSuccess: false,
			hasSavingError: false,
		});
		this.props.onClose();
	};

	openScanner = () => {
		this.setState({
			isScannerOpen: true,
		});
	};
	closeScanner = () => {
		this.setState({
			isScannerOpen: false,
		});
	};

	setBolResource = (photoResource) => {
		const { photoResources } = this.state;

		photoResources.push(photoResource);
		return this.setState({
			hasNewScanAndHasNotSave: true,
			photoResources,
		});
	};

	showZoomImageDialog = (imageSrcUrlToZoom) => {
		this.setState({ isZoomOpen: true, imageSrcUrlToZoom });
	};
	hideZoomImageDialog = () => {
		this.setState({
			imageSrcUrlToZoom: undefined,
			isZoomOpen: false,
		});
	};

	render() {
		const { open, classes, permissionMap } = this.props;
		const {
			isSaving,
			hasSavingSuccess,
			hasSavingError,
			savingError,
			hasNewScanAndHasNotSave,
			photoResources,
		} = this.state;

		const showScanFeature = permissionMap
			? permissionMap.canBetaBolScanning || permissionMap.isDwp
			: false;
		const half = parseInt(unloadingDelayReason.length / 2);

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot, paper: classes.dialogPaper }}
			>
				<DialogContent style={{ position: 'relative' }}>
					<div className={classes.dialogTitle}>
						<div>Consignee Delay</div>
					</div>

					<Grid container spacing={4} style={{ marginTop: 0, marginBottom: 0 }}>
						<Grid item xs={6}>
							{_.sortBy(unloadingDelayReason, 'display').map((delayReason, i) => {
								if (i > half) {
									return null;
								}
								return (
									<div style={{ marginTop: '4vw' }} key={delayReason.value}>
										<FormCheckbox
											{...this.setForm(delayReason.value, delayReason.display, false, false)}
											showMobileFont={true}
											gridProps={null}
										/>
									</div>
								);
							})}
						</Grid>
						<Grid item xs={6}>
							{_.sortBy(unloadingDelayReason, 'display').map((delayReason, i) => {
								if (i <= half) {
									return null;
								}
								return (
									<div style={{ marginTop: '4vw' }} key={delayReason.value}>
										<FormCheckbox
											{...this.setForm(delayReason.value, delayReason.display, false, false)}
											showMobileFont={true}
											gridProps={null}
										/>
									</div>
								);
							})}
						</Grid>
						<FormTextArea
							{...this.setForm('delayNotes', 'Additional Delay Notes')}
							variant="outlined"
							rows={3}
						/>

						{!!showScanFeature && (
							<Grid item xs={12}>
								<div className={classes.commodityFormProductInput}>
									<Button
										className={classes.scanDocumentButton}
										variant="outlined"
										color="primary"
										aria-label="add document"
										onClick={() => this.openScanner()}
									>
										Add Photos of Delay
									</Button>

									{!_.isEmpty(photoResources) && (
										<div style={{ display: 'flex', width: '100%' }}>
											{photoResources.map((photoResource) => {
												return (
													<img
														alt="scan"
														src={photoResource.url}
														style={{ height: '24vw', cursor: 'pointer', padding: '1vw' }}
														onClick={() => {
															this.showZoomImageDialog(photoResource.url);
														}}
													/>
												);
											})}

											<MobileImageZoomDialog
												open={this.state.isZoomOpen}
												onClose={this.hideZoomImageDialog}
												imageSrcUrl={this.state.imageSrcUrlToZoom}
											/>

											<div style={{ marginLeft: '2vw' }}>
												{hasNewScanAndHasNotSave && (
													<div style={{ fontSize: '120%', fontWeight: '500', marginTop: '3vw' }}>
														<span role="img" aria-label="doit">
															👇
														</span>{' '}
														Remember to submit below
													</div>
												)}
											</div>
										</div>
									)}
								</div>
							</Grid>
						)}

						<MobileScannerDialog
							//classes={classes }
							open={this.state.isScannerOpen}
							onClose={this.closeScanner}
							// freightNumber={this.freightNumberForScanner}
							setBolResource={this.setBolResource}
						/>
					</Grid>
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<MobileDeliveryDialogSavePopup
						isSaving={isSaving}
						hasSavingSuccess={hasSavingSuccess}
						hasSavingError={hasSavingError}
						savingError={savingError}
						savingSuccess={'Consignee delay saved'}
					/>

					<div style={{ display: 'flex', width: '100%', padding: '0 2vw' }}>
						<Button
							variant="contained"
							color="primary"
							aria-label="submitConsigneeDelay"
							className={classes.dialogSubmitButton}
							onClick={this.handleSaveConsigneeDelay}
							disabled={isSaving}
						>
							Submit Delay
						</Button>

						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileDeliveryConsigneeDelayDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object.isRequired,
	stopNumber: PropTypes.number,
};

export default _.flow([withStyles(styles), AuthUserContainer])(MobileDeliveryConsigneeDelayDialog);
